module.exports = __webpack_public_path__ + "static/trust-bf66d45c2caa81d7b7cec5a0e1b5f224.svg";